import {
  FETCH_CATEGORY,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_ERROR,
  ADD_CATEGORY,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_ERROR,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_ERROR,
  RESET_UPDATE_CATEGORY,
} from "constants/ActionTypes";

export const fetchCategory = () => {
  return {
    type: FETCH_CATEGORY,
  }
};

export const fetchCategorySuccess = (categoryList) => {
  return {
    type: FETCH_CATEGORY_SUCCESS,
    payload: categoryList,
  }
};

export const fetchCategoryError = (error) => {
  return {
    type: FETCH_CATEGORY_ERROR,
    payload: error
  }
};

export const addCategory = (payload) => {
  return {
    type: ADD_CATEGORY,
    payload,
  }
};

export const addCategorySuccess = (payload) => {
  return {
    type: ADD_CATEGORY_SUCCESS,
    payload,
  }
};

export const addCategoryError = (error) => {
  return {
    type: ADD_CATEGORY_ERROR,
    payload: error
  }
};

export const updateCategory = (params) => {
  return {
    type: UPDATE_CATEGORY,
    params,
  }
};

export const updateCategorySuccess = (payload) => {
  return {
    type: UPDATE_CATEGORY_SUCCESS,
    payload,
  }
};

export const updateCategoryError = (error) => {
  return {
    type: UPDATE_CATEGORY_ERROR,
    payload: error
  }
};

export const resetAddCategory = () => {
  return {
    type: RESET_UPDATE_CATEGORY,
  }
};
